import { usePlanServingSize } from '@hungryroot/plan';

export function useCustomerServingSize() {
  const servingSize = usePlanServingSize();
  return servingSize;
}
